import { createEnum } from './enum.js'

export default createEnum('Right upper lid', 'Left upper lid', 'Both upper lids');
